/**
 * Barras simples. Dos usos en el maquetado: la ocupación mensual de la pestaña Analítica y la
 * curva de patrimonio del panel de marca (variante `equity`, translúcida sobre el gradiente).
 */
import { cssPercent } from '../lib/format';
import styles from './Charts.module.css';

export interface BarPoint {
  key: string;
  label?: string;
  heightPct: number;
  title?: string;
}

interface BarChartProps {
  data: BarPoint[];
  variant?: 'default' | 'equity';
  /** Oculta las etiquetas del eje: la curva de patrimonio no las lleva. */
  showLabels?: boolean;
}

export function BarChart({ data, variant = 'default', showLabels = true }: BarChartProps) {
  if (variant === 'equity') {
    return (
      <div className={styles.equity}>
        {data.map((point) => (
          <div
            key={point.key}
            className={styles.equityBar}
            style={{ height: cssPercent(point.heightPct) }}
            title={point.title}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.bars}>
      {data.map((point) => (
        <div key={point.key} className={styles.barColumn}>
          <div
            className={styles.bar}
            style={{ height: cssPercent(point.heightPct) }}
            title={point.title}
          />
          {showLabels && point.label ? (
            <div className={`${styles.axisLabel} ${styles.axisLabelSm}`}>{point.label}</div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
